export const CLEAN_BOUNDARY_ERROR = 'CLEAN_BOUNDARY_ERROR';

/* eslint-disable no-magic-numbers */ 
export enum ERROR_STATUS {
  _400 = 400,
  _403 = 403,
  _404 = 404,
  _422 = 422,
  _500 = 500,
  _503 = 503,
  _504 = 504
}

/**
 * API errors to managed and to render as status & message or generic error
 */
export const MANAGED_ERRORS = [
  ERROR_STATUS._400,
  ERROR_STATUS._403,
  ERROR_STATUS._404,
  ERROR_STATUS._500,
  ERROR_STATUS._503,
  ERROR_STATUS._504
];
